<template>
<div class="w-full">
    <Carousel>
      <Slide
        v-for="(img, index) in list"
        :key="index"
        @click="changeIndex(1);"
      >
            <img class="rounded w-[450px] h-[350px] object-cover " :src="img" alt="">

      </Slide>

      <template #addons>
            <Navigation></Navigation>
            <Pagination></Pagination>
        </template>
    </Carousel>
</div>
</template>

<script>
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

export default {
  name: "App",
  props: ['images'],
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation
  },
  data() {
    return {
      list: [],
      sliderValue: 0,
      window: {
        width: 0,
        height: 0
      },
      sliderHeight: '300px;'
    };
  },
  methods: {
    changeIndex(index) {
      this.sliderValue = index;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      if(this.window.width > 500) {
        this.sliderHeight = '300px';
      } else {
        this.sliderHeight = '200px';
      }
    }
  },

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  mounted() {
    this.list = this.images.split(',');
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },
};
</script>

<style>
</style>
